export const GROUP_META = {
  ai_resolved: { label: "AI-resolved", color: "#16a34a" },
  ai_assisted: { label: "AI-assisted", color: "#d97706" },
  human_only: { label: "Human-only", color: "#425B76" },
  open: { label: "Open / in progress", color: "#94a3b8" },
};

export const DEFINITIONS = {
  ai_resolved: "AI-resolved: the chatbot replied first, the conversation/ticket is closed, and no human agent sent a message.",
  ai_assisted: "AI-assisted: the chatbot replied first, then a human agent replied before it was closed (handoff/escalation).",
  human_only: "Human-only: a human answered first and the bot never replied first (fallback, or the bot was down). Closed chats with no reply also land here.",
  open: "Open / in progress: the ticket is not in a closed stage (or the thread is still open when there is no ticket).",
  sender: "Bot messages = outgoing messages from the chatbot integration actor. Human messages = outgoing messages from an agent user (A-…) in the HubSpot inbox. Agent-initiated threads with no customer message are excluded.",
  reopen: "Reopened = the ticket went back to an open stage after closing (or the thread was reopened), or the same contact raised a new conversation within the reopen window.",
  total: "Conversations in the Live Chat inbox where the chatbot sent the first response.",
  closed_via_ai: "Closed conversations where the AI responded first: AI-resolved + AI-assisted.",
  containment: "AI-resolved conversations (closed with no human message) as a share of all conversations in the period.",
  escalation: "Share of AI-handled conversations where a human agent replied after the bot (AI-assisted, plus open chats already handed off).",
  ttc: "Time from conversation created to closed, for AI-resolved conversations only. Median is less skewed by long-waiting tickets.",
  csat: "Average CSAT score (1–5) for AI-resolved chats. Survey submissions are matched to the contact's conversation that closed most recently before the survey (within 14 days). Response rate = rated ÷ AI-resolved.",
  hours_saved: "AI-resolved conversations × the average human handle time set in Settings.",
  coverage: "Conversations where the AI responded first ÷ all incoming conversations.",
  frt: "First response time = first customer message → first bot (AI) or human (Human-only) reply. Baseline uses every synced Human-only conversation (last 90 days).",
  fallback: "Bot replies containing an 'I don't know'-type phrase, a hand-off promise (e.g. 'a Representative will respond') or a low-confidence marker.",
};

export const fmtNum = (v) => (v === null || v === undefined ? "—" : Number(v).toLocaleString());
export const fmtPct = (v) => (v === null || v === undefined ? "—" : `${v}%`);
export const fmtScore = (v) => (v === null || v === undefined ? "—" : Number(v).toFixed(2));

export const fmtHours = (h) => {
  if (h === null || h === undefined) return "—";
  if (h < 1) return `${Math.round(h * 60)}m`;
  if (h < 48) return `${h.toFixed(1)}h`;
  return `${(h / 24).toFixed(1)}d`;
};

export const fmtMins = (m) => {
  if (m === null || m === undefined) return "—";
  return m < 1 ? `${Math.round(m * 60)}s` : fmtHours(m / 60);
};

const iso = (d) => {
  const z = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  return z.toISOString().slice(0, 10);
};

export const presetRange = (preset) => {
  const today = new Date();
  if (preset === "quarter") {
    const q = new Date(today.getFullYear(), Math.floor(today.getMonth() / 3) * 3, 1);
    return { start: iso(q), end: iso(today) };
  }
  const days = preset === "7d" ? 6 : 29;
  return { start: iso(new Date(today.getTime() - days * 86400000)), end: iso(today) };
};

export const toParams = (f) => {
  const p = { start: f.start, end: f.end, compare: f.compare };
  ["company", "topic", "priority", "group"].forEach((k) => {
    if (f[k] && f[k] !== "all") p[k] = f[k];
  });
  return p;
};
